function timeStamp(times) {
	let timestamp = Date.parse(new Date());
	times = Date.parse(new Date(times.replace(/-/g, '/'))) / 1000;
	timestamp = timestamp / 1000;
	let letime = times - timestamp;
	let time = parseInt(letime);
	if (time == 0) {
		return 0
	}

	if (parseInt(letime) > 60) {
		let second = parseInt(letime) % 60;
		let min = parseInt(letime / 60);
		// 直接返回字符串格式：
		// time = min + "分" + second + "秒";
		// 返回对象格式：
		time = {
			day: 0,
			min: min,
			second: second
		};
		if (min > 60) {
			min = parseInt(letime / 60) % 60;
			let hour = parseInt(parseInt(letime / 60) / 60);
			// 直接返回字符串格式：
			// time = hour + "时" + min + "分" + second + "秒";
			// 返回对象格式：
			time = {
				hour: hour,
				min: min,
				second: second
			}
			if (hour >= 24) {
				hour = parseInt(parseInt(letime / 60) / 60) % 24;
				let day = parseInt(parseInt(parseInt(letime / 60) / 60) / 24);
				// 直接返回字符串格式：
				// time = day + "天" + hour + "时" + min + "分" + second + "秒";
				// 返回对象格式：
				time = {
					day: day,
					hour: hour,
					min: min,
					second: second
				}
			}
		}
	} else {
		time = {
			day: 0,
			hour: 0,
			min: 0,
			second: letime
		}
	}

	// 判断是否小于10，小于10就补零
	if (time.day < 10) {
		time.day = '0' + time.day
	} else if (time.day == undefined) {
		time.day = '00'
	}
	if (time.hour < 10) {
		time.hour = '0' + time.hour
	} else if (time.hour == undefined) {
		time.hour = '00'
	}
	if (time.min < 10) {
		time.min = '0' + time.min
	} else if (time.min == undefined) {
		time.min = '00'
	}
	if (time.second < 10) {
		time.second = '0' + time.second
	}
	// 输出结果：
	return time;
}

// 交集
function array_intersect(a, b) {
	var sa = Array.from(new Set(a.map(v => parseInt(v))));
	var sb = Array.from(new Set(b.map(v => parseInt(v))));
	return sa.filter(x => sb.includes(x));
}
// 差集
function array_diff() {
	var sa = Array.from(new Set(a.map(v => parseInt(v))));
	var sb = Array.from(new Set(b.map(v => parseInt(v))));
	return sa.filter(x => !sb.includes(x));
}

function uuid() {
	let dt = new Date().getTime();
	const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		const r = (dt + Math.random() * 16) % 16 | 0;
		dt = Math.floor(dt / 16);
		return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
	});
	return uuid;
}

function test_image(filename) {
	const imageRegex = /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff)$/i;
	return imageRegex.test(filename);
}

function is_video(filename) {
	const videoRegex = /\.(mp4|mov|avi|wmv|flv|mkv)$/i;
	return videoRegex.test(filename);
}

function get_image_icon(filename) {
	// console.log('filename',filename);
	let ext = '';
	if(filename){
		ext = filename.substring(filename.lastIndexOf('.') + 1);
	}
	switch (ext.toLowerCase()) {
		case "doc":
		case "docx":
			return require(`@/assets/images/design/file/word.png`)
		case "csv":
		case "xls":
		case "xlsx":
			return require(`@/assets/images/design/file/excel.png`)
		case "ppt":
			return require(`@/assets/images/design/file/ppt.png`)
		case "ai":
			return require(`@/assets/images/design/file/ai.png`)
		case "avi":
			return require(`@/assets/images/design/file/avi.png`)
		case "mp4":
			return require(`@/assets/images/design/file/mp4.png`)
		case "pdf":
			return require(`@/assets/images/design/file/pdf.png`)
		case "psd":
			return require(`@/assets/images/design/file/psd.png`)
		case "cdr":
			return require(`@/assets/images/design/file/cdr.png`)
		case "wav":
			return require(`@/assets/images/design/file/wav.png`)
		case "rar":
		case "zip":
			return require(`@/assets/images/design/file/zip.png`)
		default:
			return require(`@/assets/images/design/file/default.png`)
	}
}

function is_pattern_file(filename){
	const fileType = [
		'pjh','plt','boke','prj','ets','dgs','pds','fgs','gmt','bpd','gph',
		'tmp','zip','mdl','pa1','pa2','pa3','pat','sty','sg','jit','ftd',
		'sak','skc','aud','pdt','pan','pax','dxf','plt','aama','inv'
	];
	const file = filename.split('.').pop().toLowerCase();
	return fileType.includes(file);
}

function checkAvifSupport() {
	const stored = window.localStorage.getItem('avifSupported');
	if (stored !== null) {
		return stored === 'true';
	}
	
	const img = new Image();
	img.onload = function() {
		window.localStorage.setItem('avifSupported', 'true');
	};
	img.onerror = function() {
		window.localStorage.setItem('avifSupported', 'false');
	};
	img.src = 'data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=';
	
	return false;
}

module.exports = {
	timeStamp,
	array_intersect,
	array_diff,
	uuid,
	test_image,
	get_image_icon,
	is_video,
	is_pattern_file,
	checkAvifSupport
}
